import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PhotographyWebsite from "./components/PhotographyWebsite";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PhotographyWebsite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
